import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/analytics/roi/bulk-text')({ staticData: { team: 'analytics' } });
